/**
 * @flow
 * @relayHash 2a8339cda37db736fa290679e5fbe7e1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCompanyCalendarEventInput = {|
  id: string
|};
export type DeleteCompanyCalendarEventMutationVariables = {|
  input: DeleteCompanyCalendarEventInput
|};
export type DeleteCompanyCalendarEventMutationResponse = {|
  +deleteCompanyCalendarEvent: {|
    +company: {|
      +id: string,
      +name: ?string,
      +namespace: string,
      +sundayHoursStart: ?string,
      +sundayHoursEnd: ?string,
      +mondayHoursStart: ?string,
      +mondayHoursEnd: ?string,
      +tuesdayHoursStart: ?string,
      +tuesdayHoursEnd: ?string,
      +wednesdayHoursStart: ?string,
      +wednesdayHoursEnd: ?string,
      +thursdayHoursStart: ?string,
      +thursdayHoursEnd: ?string,
      +fridayHoursStart: ?string,
      +fridayHoursEnd: ?string,
      +saturdayHoursStart: ?string,
      +saturdayHoursEnd: ?string,
      +calendarEvents: $ReadOnlyArray<{|
        +id: string,
        +name: string,
        +isFullDay: boolean,
        +isOpen: boolean,
        +startAt: any,
        +endAt: any,
      |}>,
    |}
  |}
|};
export type DeleteCompanyCalendarEventMutation = {|
  variables: DeleteCompanyCalendarEventMutationVariables,
  response: DeleteCompanyCalendarEventMutationResponse,
|};
*/


/*
mutation DeleteCompanyCalendarEventMutation(
  $input: DeleteCompanyCalendarEventInput!
) {
  deleteCompanyCalendarEvent(input: $input) {
    company {
      id
      name
      namespace
      sundayHoursStart
      sundayHoursEnd
      mondayHoursStart
      mondayHoursEnd
      tuesdayHoursStart
      tuesdayHoursEnd
      wednesdayHoursStart
      wednesdayHoursEnd
      thursdayHoursStart
      thursdayHoursEnd
      fridayHoursStart
      fridayHoursEnd
      saturdayHoursStart
      saturdayHoursEnd
      calendarEvents {
        id
        name
        isFullDay
        isOpen
        startAt
        endAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteCompanyCalendarEventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCompanyCalendarEvent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCompanyCalendarEventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "namespace",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "sundayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "sundayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mondayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mondayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tuesdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tuesdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "wednesdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "wednesdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thursdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thursdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fridayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fridayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "saturdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "saturdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "calendarEvents",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanyCalendarEvent",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isFullDay",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isOpen",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCompanyCalendarEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCompanyCalendarEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCompanyCalendarEventMutation",
    "id": null,
    "text": "mutation DeleteCompanyCalendarEventMutation(\n  $input: DeleteCompanyCalendarEventInput!\n) {\n  deleteCompanyCalendarEvent(input: $input) {\n    company {\n      id\n      name\n      namespace\n      sundayHoursStart\n      sundayHoursEnd\n      mondayHoursStart\n      mondayHoursEnd\n      tuesdayHoursStart\n      tuesdayHoursEnd\n      wednesdayHoursStart\n      wednesdayHoursEnd\n      thursdayHoursStart\n      thursdayHoursEnd\n      fridayHoursStart\n      fridayHoursEnd\n      saturdayHoursStart\n      saturdayHoursEnd\n      calendarEvents {\n        id\n        name\n        isFullDay\n        isOpen\n        startAt\n        endAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd0d4165253256fa54ff8f39a8c61a6bf';
module.exports = node;
